import React, { useState, useRef, useEffect } from "react";
import { Box, Button, Modal, Typography, IconButton, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./modal.css";

const ConfirmationModel = ({ open, handleOpen, data, handleModelAction, languageData }) => {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const descriptionRef = useRef(null);

  const successAgree = () => {
    handleOpen(false);
    handleModelAction();
  };

  useEffect(() => {
    if (!open) {
      setIsButtonEnabled(false);
    } else {
      // Check if the content is scrollable
      setTimeout(() => {
        if (descriptionRef.current) {
          const { scrollHeight, clientHeight } = descriptionRef.current;
          setIsButtonEnabled(scrollHeight <= clientHeight);
        }
      }, 100); // Delay ensures the content is fully rendered
    }
  }, [open, data]);

  return (
    <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          padding: "10px 20px",
          borderRadius: "10px",
          width: { xs: "90%", sm: "80%", md: "60%", lg: "50%" },
          maxHeight: "80vh",
          overflow: "auto",
        }}
      >
        <Typography
          id="modal-modal-title"
          component="h5"
          sx={{ padding: "0px 15px 10px 0px", fontSize: { xs: "14px", sm: "16px" }, fontWeight: "bold" }}
          dangerouslySetInnerHTML={{ __html: data?.PrivacyNoticeTitle }}
        ></Typography>
        <IconButton
          onClick={() => handleOpen(false)}
          sx={{
            position: "absolute",
            top: 5,
            right: 5,
            color: "#212129",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Divider />
        <Typography
          id="modal-modal-description"
          ref={descriptionRef}
          onScroll={(e) => {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            setIsButtonEnabled(scrollTop + clientHeight >= scrollHeight - 1);
          }}
          sx={{
            mt: 2,
            height: "350px",
            overflowY: "auto",
            fontSize: "12px",
          }}
          dangerouslySetInnerHTML={{ __html: data?.PrivacyNoticeContent }}
        ></Typography>
        <Box id="modal-modal-description" sx={{ m: 1, mr: 1, display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            onClick={() => handleOpen(false)}
            sx={{
              fontWeight: 800,
              padding: "10px",
              borderRadius: "20px",
              minWidth: "100px",
              backgroundColor: "white",
              color: "#212129",
              ":hover": {
                opacity: 0.5,
              },
            }}
          >
            {("close").toUpperCase()}
          </Button>
          <Button
            variant="contained"
            onClick={successAgree}
            sx={{
              padding: "10px",
              borderRadius: "20px",
              minWidth: "100px",
              backgroundColor: isButtonEnabled ? "#212129" : "#BFAE81",
              ":hover": {
                opacity: 0.5,
              },
              "&.Mui-disabled": {
                backgroundColor: "darkGray",
                color: "white",
              },
            }}
            disabled={!isButtonEnabled}
          >
            {languageData?.Key29?.toUpperCase()}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModel;
